<header class="w-full p-2 border-b border-gray-200">
  <mat-toolbar>
    <mat-toolbar-row class="flex items-center justify-between">
      <div class="flex items-center gap-5">
        <a routerLink="/">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            version="1.1"
            viewBox="0 0 1080 1080"
            class="w-10 h-10 fill-[#0b568c]"
          >
            <g>
              <rect
                x="161.1"
                y="218.3"
                class="st0"
                width="80.8"
                height="80.8"
              />
              <polygon
                class="st0"
                points="0,459.9 0,540.5 80.6,540.5 80.6,460.5"
              />
              <rect x="80.6" y="459.9" class="st0" width="0.6" height="0.6" />
              <path
                class="st0"
                d="M974.5,245.4c-72.8-63.9-186.4-94.9-347.5-94.9H399.6v0H241.8v67.7h81v80.6h-81v80.6h-80.6v-80.6H80.6v80.6   l0.6,80.6h80v80.6H80.6v80.6H0v80.6h0.2v0.1h80.7v80.4h79.5V863h81.5v66.6h97h60.7H627c161.1,0,274.8-31.1,347.5-94.9   c71-62.3,105.5-158.7,105.5-294.6C1080,404.1,1045.5,307.8,974.5,245.4z M240.5,700.4h-80.8v-80.8h80.8V700.4z M322.8,782.3h-81   v-80.6h81V782.3z M322.8,540.5h-81v-80.6h81V540.5z M621.2,784.7h-150V295.3h150c206.6,0,260.8,71.6,260.8,244.7   C882.1,713.1,827.8,784.7,621.2,784.7z"
              />
            </g>
          </svg>
        </a>
        <a routerLink="/" class="text-xl font-medium hidden sm:block">
          Danzai <span class="font-light">Licencias</span>
        </a>
      </div>

      <div class="flex items-center gap-5">
        @if (loading) {
        <div class="w-48 h-6 bg-gray-200 cursor-wait animate-pulse"></div>
        <div class="w-8 h-6 bg-gray-200 cursor-wait animate-pulse"></div>
        }@else{
        <div class="hidden sm:flex sm:items-center sm:gap-2">
          <mat-icon>person</mat-icon>
          <span class="text-lg font-normal">{{
            profile.displayName || profile.username
          }}</span>
        </div>
        <button
          type="button"
          mat-icon-button
          [matMenuTriggerFor]="menu"
          aria-label="Menú"
          aria-hidden="false"
        >
          <mat-icon class="text-[#1a1b1f]">menu</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
          <button
            type="button"
            routerLink="/"
            aria-hidden="false"
            aria-label="Inicio"
            mat-menu-item
          >
            <mat-icon>home</mat-icon>
            <span class="font-normal">Inicio</span>
          </button>
          <button
            type="button"
            routerLink="/settings"
            aria-hidden="false"
            aria-label="Configuración"
            mat-menu-item
          >
            <mat-icon>settings</mat-icon>
            <span class="font-normal">Configuración</span>
          </button>
          <button
            type="button"
            aria-hidden="false"
            aria-label="Salir"
            mat-menu-item
            (click)="logout()"
          >
            <mat-icon>logout</mat-icon>
            <span class="font-normal">Salir</span>
          </button>
        </mat-menu>
        }
      </div>
    </mat-toolbar-row>
  </mat-toolbar>
</header>
